module.exports = "images/what-drives-us_poster@3x.webp";